import { ApiFilePathTypes } from "@/types/file.types.ts";
import { SelectItem } from "@skailer-com/uikit";

export interface ApiFile {
  id: number;
  name: string;
  file_type: ApiFilePathTypes;
  mime_type: string;
  size: number;
  uuid: string;
  color_palette?: string[];
  url_permanent?: string;
}

export enum ApiEntityTypes {
  applicant = "applicant",
  candidate = "candidate",
  employee = "employee",
  blog_post = "blog_post",
  task = "task",

  // НЕ НАДО ИСПОЛЬЗОВАТЬ - устаревшие типы файлов
  other = "other",
}

export interface ApiPartialDate {
  year: number | null;
  month: number | null;
  day: number | null;
}

export interface Time extends SelectItem {
  date: Date;
}

export interface Period {
  start: Date;
  end: Date;
  title: string;
  key: string;
}

export enum ContactTypes {
  telegram = "telegram",
  whatsapp = "whatsapp",
  viber = "viber",
}

export interface ApiOperationResult {
  success: boolean;
}

export enum Rounding {
  up = "up",
  down = "down",
  usual = "usual",
}

export interface ApiReaction {
  emoji: string;
  count: number;
  is_mine: boolean;
  employee_ids: number[];
}

export enum ApiReactionEntityTypes {
  blog_post = "blog_post",
  comment = "comment",
}

export enum AppEntityViewKey {
  blog_empty_subscribes = "blog_empty_subscribes",
}

export interface ApiIdObject {
  id: number;
}

export interface ApiIdTitle {
  id: number | string;
  title: string;
}

export const ColumnSizes = {
  tiny: {
    minSize: 36,
    maxSize: 60,
    size: 48,
  },

  narrow: {
    minSize: 80,
    maxSize: 120,
    size: 80,
  },

  status: {
    minSize: 100,
    maxSize: 150,
    size: 120,
  },

  standard: {
    minSize: 120,
    maxSize: 180,
    size: 150,
  },

  middle: {
    minSize: 160,
    maxSize: 200,
    size: 220,
  },

  wide: {
    minSize: 200,
    maxSize: 500,
    size: 350,
  },

  ultraWide: {
    minSize: 280,
    maxSize: 500,
    size: 400,
  },

  employee: {
    minSize: 250,
    maxSize: 400,
    size: 300,
  },

  date: {
    minSize: 110,
    maxSize: 180,
    size: 110,
  },

  historicalDate: {
    minSize: 130,
    maxSize: 200,
    size: 150,
  },

  actions: {
    minSize: 40,
    maxSize: 180,
    size: 40,
  },

  stageFlowTitle: {
    minSize: 320,
    maxSize: 320,
    size: 320,
  },
  stageFlowName: {
    minSize: 160,
    maxSize: 160,
    size: 160,
  },
  stageFlowVacancy: {
    minSize: 280,
    maxSize: 280,
    size: 280,
  },
  stageFlowStage: {
    minSize: 120,
    maxSize: 120,
    size: 120,
  },
} as const;

export enum AppDistribution {
  skailer = "skailer",
  headly = "headly",
  on_premise = "on_premise",
}

export enum AppEnvironment {
  local = "local",
  stage = "stage",
  demo = "demo",
  production = "production",
  test = "test",
}

export enum ApiCreationSource {
  manual = "manual",
  workflow = "workflow",
}
